import { useState } from 'react';
import Calendar from 'react-calendar';

export default function DashboardCalendario({ stros }) {
  const [selectedDate, setSelectedDate] = useState(null);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  // Build a map of dates -> stros with vencimiento on that date
  const vencimientosMap = {};
  stros.forEach(s => {
    if (s.fechaVencimiento) {
      const dateKey = s.fechaVencimiento; // "YYYY-MM-DD"
      if (!vencimientosMap[dateKey]) {
        vencimientosMap[dateKey] = [];
      }
      vencimientosMap[dateKey].push(s);
    }
  });

  const formatDateKey = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
  };

  const tileContent = ({ date, view }) => {
    if (view !== 'month') return null;
    const key = formatDateKey(date);
    const strosEnDia = vencimientosMap[key];
    if (!strosEnDia || strosEnDia.length === 0) return null;

    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);

    let dotClass = 'calendar-dot--proximo';
    if (dateObj < today) {
      dotClass = 'calendar-dot--vencido';
    } else if (dateObj.getTime() === today.getTime()) {
      dotClass = 'calendar-dot--hoy';
    }

    return (
      <div className='calendar-dot-indicator'>
        <span className={`calendar-dot ${dotClass}`}></span>
        {strosEnDia.length > 1 && <span className={`calendar-dot ${dotClass}`}></span>}
        {strosEnDia.length > 2 && <span className={`calendar-dot ${dotClass}`}></span>}
      </div>
    );
  };

  const selectedKey = selectedDate ? formatDateKey(selectedDate) : null;
  const selectedStros = selectedKey ? (vencimientosMap[selectedKey] || []) : [];

  const formatDisplayDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString('es-AR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    });
  };

  return (
    <div className='dashboard-card'>
      <div className='dashboard-card-header'>
        <span className='dashboard-card-title'>
          <i className='bi bi-calendar3'></i>
          Calendario de Vencimientos
        </span>
        <span className='dashboard-card-badge'>
          {Object.keys(vencimientosMap).length} días
        </span>
      </div>
      <div className='dashboard-calendar-wrapper'>
        <div className='dashboard-calendar'>
          <Calendar
            onClickDay={handleDateClick}
            value={selectedDate}
            tileContent={tileContent}
            locale='es-AR'
          />
        </div>

        {selectedDate && (
          <div className='calendar-day-detail'>
            <div className='calendar-day-detail-title'>
              <i className='bi bi-calendar-event'></i>
              {formatDisplayDate(selectedDate)}
              {selectedStros.length > 0 && ` — ${selectedStros.length} vencimiento${selectedStros.length > 1 ? 's' : ''}`}
            </div>
            {selectedStros.length === 0 ? (
              <div style={{ fontSize: '12px', color: '#94a3b8', textAlign: 'center', padding: '12px' }}>
                Sin vencimientos en este día
              </div>
            ) : (
              selectedStros.map((s, idx) => (
                <div className='calendar-day-stro' key={idx}>
                  <div>
                    <div className='calendar-day-stro-nro'>
                      Stro #{s.nroStro?.toString().slice(3) || s.nroStro}
                    </div>
                    <div className='calendar-day-stro-dom'>
                      {s.dom || 'Sin dominio'} — {s.nombreAseg || 'Sin asegurado'}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}
